module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "79%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439633854_i0004.jpg",
      "src": "images/e9781439633854_i0004.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("John Vinall (1736–1823), for whom Vinalhaven was named, is shown here in this "), _c('em', {
    staticClass: "i"
  }, [_vm._v("c.")]), _vm._v(" 1785 portrait by John Mason Furness. He was a Bostonian, a “man of influence,” a teacher, a merchant, and an attorney. His son William had settled in the Fox Islands. When the inhabitants of the islands petitioned the General Court of Massachusetts for title to their lands, John was their attorney. North and South Fox Islands were incorporated as the town of Vinalhaven on June 25, 1789.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6bf79b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439633854_fm03.vue
// module id = 72
// module chunks = 0